import { Application } from 'types/Application';

export const fullName = (userData: Application) =>
	`${userData?.systemAnswers?.name || userData?.programMembership?.user?.firstName} ${
		userData?.systemAnswers?.surname || userData?.programMembership?.user?.lastName
	}`;
